import { put, takeLatest, delay } from "redux-saga/effects";
import { postChangePasswordApi } from "store/api/LoginApi";
import { CHANGE_PASSWORD_REQUEST } from "../../actions/LoginPageAction/actionTypes";
import { getIsApp } from "config/constant";

import * as globalAction from "../../actions/GlobalAction";
import * as loginPageAction from "../../actions/LoginPageAction";
import * as homeAction from "../../actions/HomePageAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postChangePassword(action) {
	const { oldPassword, newPassword, onConfirm } = action.params;

	const data = {
		oldPassword,
		newPassword
	};

	yield put(globalAction.openLoadingPage());
	yield put(
		globalAction.setMessageChangePassword({
			statusCode: 0,
			message: ""
		})
	);
	const res = yield postChangePasswordApi(data);
	try {
		if (res?.code === 0) {
			const isApp = getIsApp();
			yield showMessage(false, res?.message);
			yield put(homeAction.setCRMShopInfoDetail({}));
			yield delay(1000);
			if (typeof window !== undefined && isApp) {
				window?.ReactNativeWebView?.postMessage("LOGOUT");
			} else {
				yield put(loginPageAction.logoutRequest());
			}
		} else {
			if (res?.code === -1026 || res?.code === -1033) {
				yield put(
					globalAction.setMessageChangePassword({
						statusCode: res?.code,
						message: res?.message
					})
				);
			} else if (res?.code === -1027) {
				onConfirm({
					statusCode: res?.code,
					message: res?.message
				});
			} else {
				yield showMessage(true, res?.message);
			}
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postChangePasswordSaga() {
	yield takeLatest(CHANGE_PASSWORD_REQUEST, postChangePassword);
}

export default postChangePasswordSaga;
